export const DEFAULTS = {
  loanAmount: 100000,
  interestRate: 10,
  loanPeriod: 12,
  monthlyExtraPayment: 1000,
  sipReturnRate: 12,
  sipPeriod: 12,
  sipTarget: 0,
  sipAmount: 0,
};

export const CHART_COLORS = {
  interest: "#f87171",
  principal: "#60a5fa",
  extraPayment: "#a78bfa",
  lumpsum: "#34d399",
  balance: "#8884d8",
  sipInvestment: "#a78bfa",
  sipGrowth: "#34d399",
  sipTotal: "#059669",
};
